import React from 'react';
import { Box, TextField, MenuItem, Typography, Button } from '@mui/material';
import PropTypes from 'prop-types';
import useTranslation from '../../../../hooks/useTranslation';
import { EDITABLE_FIELD_GROUPS } from './importReviewConfig';

const styles = {
  container: {
    padding: '16px 20px',
  },
  group: {
    marginBottom: '16px',
  },
  groupTitle: {
    fontWeight: 600,
    marginBottom: '8px',
  },
  fieldRow: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: '12px',
  },
  field: {
    minWidth: '220px',
    flex: '1 1 220px',
  },
  actions: {
    display: 'flex',
    justifyContent: 'flex-end',
    gap: '10px',
    marginTop: '4px',
  },
};

const ImportRowEditForm = ({ draft, issuesByField, onFieldChange, onSave, onCancel, saving }) => {
  const { t } = useTranslation();

  return (
    <Box sx={styles.container}>
      {EDITABLE_FIELD_GROUPS.map((group) => (
        <Box key={group.key} sx={styles.group}>
          <Typography variant="subtitle2" sx={styles.groupTitle}>
            {t(`labels.import_preview.${group.titleKey}`)}
          </Typography>
          <Box sx={styles.fieldRow}>
            {group.fields.map((field) => {
              const issue = issuesByField[field.name];
              const sharedProps = {
                size: 'small',
                label: t(`labels.import_preview.${field.labelKey}`),
                value: draft[field.name] || '',
                onChange: (e) => onFieldChange(field.name, e.target.value),
                error: Boolean(issue),
                helperText: issue?.message,
                sx: styles.field,
              };
              return field.type === 'select' ? (
                <TextField key={field.name} select {...sharedProps}>
                  {field.options.map((option) => (
                    <MenuItem key={option} value={option}>{t(`labels.${option}`)}</MenuItem>
                  ))}
                </TextField>
              ) : (
                <TextField key={field.name} {...sharedProps} />
              );
            })}
          </Box>
        </Box>
      ))}
      <Box sx={styles.actions}>
        <Button variant="outlined" onClick={onCancel} disabled={saving}>{t('labels.import_preview.cancel_edit')}</Button>
        <Button variant="contained" onClick={onSave} disabled={saving}>{t('labels.import_preview.save_and_check')}</Button>
      </Box>
    </Box>
  );
};

ImportRowEditForm.propTypes = {
  draft: PropTypes.object.isRequired,
  issuesByField: PropTypes.object.isRequired,
  onFieldChange: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  saving: PropTypes.bool,
};

export default ImportRowEditForm;
